import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FaFilter, FaPen, FaPlus, FaSearch, FaSyncAlt, FaTrash } from 'react-icons/fa';
import { useMemo } from "react";
import { API_URL_All } from '../../api';
import axios from "axios";
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import { CheckingTicket, LockingTicket } from '../tickets/Tickets';
import axiosInstance from '../../axiosInstance';
import ReconciliationPaymentConfirmModal, { buildPaymentSummary } from '../reconciliation/ReconciliationPaymentConfirmModal';

const ContactOrderVatReview = ({ data, handleSearch, canEdit = false, canDelete = true, nestedModal = false }) => {
  const [visibleMiniPopup, setVisibleMiniPopup] = useState(true);
  const [removedItems, setRemovedItems] = useState([]);

  const [show, setShow] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  const [model, setModel] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);

  const filteredItems = useMemo(() => {
    const items = Array.isArray(model?.items) ? model.items : [];
    if (data?.lineId == null) return items;
    return items.filter((item) => Number(item?.lineId) === Number(data.lineId));
  }, [model, data?.lineId]);

  const totalMoney = useMemo(() => {
    return filteredItems.reduce(
      (sum, item) => sum + (Number(item.money) || 0),
      0
    );
  }, [filteredItems]);
  const totalMoneyAfterTax = useMemo(() => {
    return filteredItems.reduce(
      (sum, item) => sum + (Number(item.moneyAfterTax) || 0),
      0
    );
  }, [filteredItems]);

  const displayedStats = useMemo(() => {
    if (data?.lineId == null) {
      return {
        orderCount: model.orderCount,
        money: model.money,
        contactAfterTax: model.contactAfterTax,
        contactFee: model.contactFee,
        contactFeeTax: model.contactFeeTax,
      };
    }
    const sum = (key) => filteredItems.reduce((t, it) => t + (Number(it?.[key]) || 0), 0);
    return {
      orderCount: filteredItems.length,
      money: sum('money'),
      contactAfterTax: sum('moneyAfterTax'),
      contactFee: sum('contactFee'),
      contactFeeTax: sum('moneyFeeTax'),
    };
  }, [data?.lineId, model, filteredItems]);

  
  useEffect(() => {
    setVisibleMiniPopup(true);
    retrieveModalData(data);
  }, [data]);

  const retrieveModalData = async (params) => {
    if (params.id) {
      try {
        var urlApi = `/api/invoices/getContactInvoice?id=${params.id}`;
        const response = await axiosInstance.get(urlApi);
        var obj = response.data;
        if (obj.success === false) {
          toast.error(obj.message);
          return;
        }
        var model = obj.data;
        model.checkingItems = model.items.filter(item => item.contactingId !== null && item.contactingId !== 13);
        setModel(model);
        setShow(true);
      } catch (error) {
        console.error(error);
        setModel({ error: error.message });
        toast.error(error.message);
      }
      return;
    }
    const textIds = params.listIds.join(';');
    setModel({});
    try {
      var urlApi = `/api/invoices/getInvoiceContactVatReview?codes=${textIds}`;
      const response = await axiosInstance.get(urlApi);
      var obj = response.data;
      if (obj.success === false) {
        toast.error(obj.message);
        return;
      }

      setModel(obj.data);
      var model = obj.data;
      model.checkingItems = model.items.filter(item => item.contactingId !== null && item.contactingId !== 13);
      setModel(model);
      setShow(true);
    } catch (error) {
      console.error(error);
      setModel({ error: error.message });
      toast.error(error.message);
    }
  };


  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);

    setRemovedItems([]);
    if (nestedModal && handleSearch) {
      handleSearch();
    }
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    try {
      var requestApi = `/api/invoices/saveContactOrderInvoiceVat`;

      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      console.log(response.data);
      //if (handleSearch) handleSearch();
      retrieveModalData({ id: response.data.data });
    } catch (error) {
      toast.error(error.message);
    }

  };

  const handleExportInvoice = async (param) => {
    var requestApi = `${API_URL_All}/api/invoices/downloadContactInvoiceVat?id=${param.id}`;
    var fileName = `Doi_soat_doi_tac_${param.id}.xlsx`;
    if (!param.id) {
      fileName = `Doi_soat_doi_tac_preview.xlsx`;

      const avaiableIds = data.listIds.filter(id => !removedItems.includes(id));
      const codes = avaiableIds.join(';');
      requestApi = `${API_URL_All}/api/invoices/downloadContactInvoiceVat?codes=${codes}`;
    }
    general.downloadFile(requestApi, fileName);
  };

  const handlePaymentConfirm = () => {
    if (!canEdit) {
      toast.warning("Bạn không có quyền cập nhật đối soát.");
      return;
    }
    setShowPaymentConfirm(true);
  };

  const handlePaymentSuccess = () => {
    if (handleSearch) handleSearch();
    handleModalClose();
  };

  const getClassWarning = (contactingId) => {
    if (!contactingId || contactingId === 13) {
      return "";
    }
    return "contacting";
  };

  const handleRemoveOrder = (orderId) => {
    const updatedRemovedItems = [...removedItems, orderId];
    setRemovedItems(updatedRemovedItems);

    const newListIds = data.listIds.filter(
      id => !updatedRemovedItems.includes(id)
    );

    data = { ...data, listIds: newListIds };
    retrieveModalData(data);
  }
  const handleDeletInvoice = (e) => {
    if (!canDelete) return;
    general.openConfirm(async () => {
      try {
        var requestApi = `/api/invoices/deleteContactInvoice?id=${model.id}`;
        const response = await axiosInstance.get(requestApi);

        if (!response.data.success) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        if (handleSearch) handleSearch();
        handleModalClose();

      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    })
  };

  return (
    <>
    <Modal
      show={show}
      onHide={handleModalClose}
      size="fullscreen"
      dialogClassName="modal-popupfull"
      className={nestedModal ? "accounting-nested-modal" : ""}
      backdropClassName={nestedModal ? "accounting-nested-modal-backdrop" : undefined}
      enforceFocus={!nestedModal}
    >
      <div className="modal-dialog11 modal-fullscreen11">
        <form id="order_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.id && (<span className="record_id">ID: {model.id}</span>)}
              <div>
                <h5 className="modal-title">{model.id ? `Đối tác: Chi tiết hóa đơn VAT` : 'Đối tác: Xem trước hóa đơn đối soát VAT'}</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body">

              <div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Mã đối tác: </label>
                      <div className="col-md-9">
                        <b>{model.contactCode}</b>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Tổng đơn: </label>
                      <div className="col-md-9">
                        <b>{general.formatNumber(displayedStats.orderCount)}</b>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Tên đối tác: </label>
                      <div className="col-md-9">
                        <b>{model.contactCode}</b>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Ngày tạo: </label>
                      <div className="col-md-2">
                        <b>{model.createdTimeText}</b>
                      </div>
                      <div className="col-md-7">
                        <CheckingTicket checkingId={model.checkingId} checkingName={model.checkingName} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">MST: </label>
                      <div className="col-md-9">
                        <b>{model.taxCode}</b>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      {model.id && (
                        <div className="col-md-12">
                          <div className="row">
                            <label className="form-label col-3">Nội dung: </label>
                            <div className="col-9">
                              <b>{model.name}</b>
                            </div>
                          </div>
                        </div>
                      )}
                      {!model.id && (
                        <div className="col-md-12">
                          <div className="row">
                            <label className="form-label col-form-label col-3"><span className="required1">Nội dung</span></label>
                            <div className="col-9">
                              <input type="text" className="form-control" placeholder="Nội dung đối soát" data-required1="Phải nhập mục này" autoComplete="off" value={model.name} onChange={(e) => setModel({ ...model, name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

              <div className="row mb-2">
              </div>

              </div>

              <section className="p-1 ">
                <div className="table-responsive border table-normal table-sticky">
                  <table className="table table-striped border-normal table-bordered">
                    <thead className="table-primary head-01">
                      <tr>
                        <th className='sticky text-center' width="21px">STT</th>

                        <th className="text-center">Ngày</th>
                        <th className="text-center">Mã vận đơn TQ</th>
                        <th><span>Tên sản phẩm</span></th>

                        <th className="text-center">Số lượng</th>
                        <th className="text-center"><span data-note="Vnđ">Giá khai</span></th>
                        <th className="text-center"><span data-note="Vnđ">Thành tiền</span></th>

                        <th colspan="2" className="text-center"><span data-note="%">Thuế NK</span></th>
                        <th colspan="2" className="text-center"><span data-note="%">VAT</span></th>

                        <th className="text-center"><span>Tổng sau VAT</span></th>
                        <th className="text-center">Phí đầu mục</th>
                        <th className="text-center">Phí ủy thác</th>
                        <th className="text-center">KG</th>
                        <th className="text-center">M3</th>
                        <th className="text-center"><span data-note="Vnđ">Tiền cước</span></th>
                        <th className="text-center"><span data-note="Vnđ">Phụ phí</span></th>
                        <th className="text-center"><span data-note="Vnđ">Phí dịch vụ</span></th>
                        <th className="text-center"><span data-note="Vnđ">Tổng phí</span><div className="small">Phí + thuế</div></th>
                        <th className="text-center">Tổng hoàn</th>
                        <th>Ghi chú</th>
                      </tr>
                    </thead>
                    {filteredItems.map((item, index) => (
                      <tbody className="tbody-row">
                        <tr key={index} className={getClassWarning(item.contactingId)}>
                          <td className='sticky text-center' title={`Id: ${item.id}`}>
                            {index + 1}
                          </td>
                          <td className="text-success text-center">{general.formatDate(item.createdAt)}</td>
                          <td className="text-success text-center">{item.cnCode}</td>
                          <td className='text-success text-start'>{item.productName}</td>


                          <td className="text-success text-center">{item.quantity}</td>
                          <td className="text-success text-center">{general.formatNumber(item.priceDeclare)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.money)}</td>

                          <td className="text-success text-center">{general.formatDecimal(item.taxImport)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.moneyTaxImport)}</td>

                          <td className="text-success text-center">{general.formatDecimal(item.taxVat)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.moneyVat)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.moneyAfterTax)}</td>

                          <td className="text-success text-center">{general.formatNumber(item.contactFeeItem)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.contactFeeEntrust)}</td>

                          <td className="text-success text-center">{general.formatDecimal(item.weight)}</td>
                          <td className="text-success text-center">{general.formatDecimal(item.size)}</td>
                          <td className="text-success text-center">{general.formatDecimal(item.contactFeeNormal)}</td>
                          <td className="text-success text-center">{general.formatDecimal(item.contactFeeSurcharge)}</td>
                          <td className="text-success text-center">{general.formatDecimal(item.contactFee)}</td>

                          <td className="text-success text-center" title={`Fee: ${general.formatNumber(item.fee)}`}>{general.formatNumber(item.moneyFeeTax)}</td>

                          <td className="text-success text-center"></td>
                          <td className="text-success text-start">{general.formatDecimal(item.note)}</td>
                        </tr>
                      </tbody>
                    ))}
                    <tbody>
                      <tr className="font-weight-bold">
                        <td colSpan="6">Tổng</td>
                        <td>{general.formatNumber(displayedStats.money)}</td>
                        <td colSpan="4"></td>
                        <td>{general.formatNumber(displayedStats.contactAfterTax)}</td>
                        <td colSpan="6"></td>
                        <td>{general.formatNumber(displayedStats.contactFee)}</td>
                        <td>{general.formatNumber(displayedStats.contactFeeTax)}</td>
                        <td>{general.formatNumber(0)}</td>
                        <td></td>
                        
                      </tr>
                    </tbody>

                    <tbody>
                      {errorMessage === '' && loaded && filteredItems.length === 0 && (
                        <tr>
                          <td colSpan="21" className="text-center">Không tìm thấy dữ liệu</td>
                        </tr>
                      )}
                      {errorMessage !== '' && (
                        <tr>
                          <td colSpan="21" className="text-center">{errorMessage}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </section>








            </div>
            <div className="modal-footer text-end">
              {!model.id && (
                
                <div className="flex-between w-100">
                  <div className="d-flex align-items-center">
                    <span className="btn-sm btn btn-primary me-2" onClick={(e) => handleExportInvoice({ codes: model.codes })}>Xuất excel</span>
                    
                  </div>
                  <div>

                    <button type="submit" className="btn-sm btn btn-primary">Xác nhận đối soát</button>
                  </div>
                </div>

              )}
              {model.id && (
                <div className="flex-between w-100">
                  <div className="d-flex align-items-center">
                    <span className="btn-sm btn btn-primary me-2" onClick={(e) => handleExportInvoice({ id: model.id })}>Xuất excel</span>
                    {canDelete && model.isAdmin && (
                      <button type="button" className="btn-small" onClick={() => handleDeletInvoice()} >Xóa</button>
                    )}
                  </div>
                  <div>
                    {model.checkingId === 14 && canEdit && (
                      <span className="btn-sm btn btn-primary me-2" onClick={() => handlePaymentConfirm()}>Xác nhận thanh toán</span>
                    )}
                    <button onClick={(e) => { handleModalClose() }} type="button" className="btn-sm btn btn-secondary">Đóng</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
        {model.checkingItems && model.checkingItems.length > 0 && visibleMiniPopup && (

          <div className="mini-popup top_right">
            <div className="mini-popup-header">
              <span>Mã đơn đã đối soát</span>
              <i className="close-i close-i0" title="Close" onClick={(e) => setVisibleMiniPopup(false)}></i>
            </div>
            <div>
              {model.checkingItems.map((item, index) => (
                <div className="mini-popup-item" key={index}>{item.cnCode}</div>
              ))}
            </div>
          </div>
        )}

      </div>
    </Modal>
    <ReconciliationPaymentConfirmModal
      show={showPaymentConfirm}
      onHide={() => setShowPaymentConfirm(false)}
      onSuccess={handlePaymentSuccess}
      completeApi="/api/invoices/completeContactInvoice"
      payloadBase={model}
      summary={buildPaymentSummary(model, "partner")}
      accountLabel="Tài khoản chi tiền"
    />
    </>
  );
};

export default ContactOrderVatReview;
